import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './Package.scss';
import PackageFree from './PackageFree';
import PackagePrice from './PackagePrice';
import {
  TaxTypes,
  TypeCycle,
  TypeSelectedOffer,
} from '../../../types/general-types';
import classNames from 'classnames';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import SaleBadge from './SaleBadge/SaleBadge';

export interface PackageProps
  extends WithTranslation,
    InjectedExperimentsProps {
  mostPopular: boolean;
  currentPlan: boolean;
  packageName: string;
  packageSlogan: string;
  packageFree: boolean;
  priceAmount?: number;
  priceCurrency?: string;
  cycles?: TypeCycle[];
  isEnabled?: boolean;
  productId?: string;
  selectedOffer: TypeSelectedOffer;
  productIndex: number;
  discountAmount?: number;
  taxType?: TaxTypes;
  isCTAPrimary?: boolean;
  isSaleOn: boolean;
}

class Package extends React.Component<PackageProps> {
  render() {
    const {
      t,
      mostPopular,
      packageName,
      packageSlogan,
      currentPlan,
      packageFree,
      priceAmount,
      priceCurrency,
      selectedOffer,
      productId,
      isEnabled,
      productIndex,
      discountAmount,
      taxType,
      isCTAPrimary,
      isSaleOn,
    } = this.props;

    const cycles = this.props.cycles || [];

    return (
      <div
        className={classNames(s.root, {
          [s.isBadgeShown]: mostPopular || currentPlan,
          [s.showHoverAnimation]: !!isEnabled,
        })}
        data-hook="package"
      >
        {mostPopular && !currentPlan ? (
          <div className={s.mostPopular} data-hook="package-mostPopular">
            {t('package.mostPopular')}
          </div>
        ) : null}
        {currentPlan ? (
          <div className={s.currentPlan} data-hook="package-currentPlan">
            {t('package.currentPlan')}
          </div>
        ) : null}
        <div
          className={classNames(s.box, {
            [s.isBadgeShown]: mostPopular || currentPlan,
            [s.isMostPopular]: mostPopular && !currentPlan,
            [s.showHoverAnimation]: !!isEnabled,
          })}
          data-hook="package-box"
        >
          {discountAmount && <SaleBadge />}
          <div className={s.name} data-hook="package-name">
            {packageName}
          </div>
          <div className={s.slogan} data-hook="package-slogan">
            {packageSlogan}
          </div>
          {packageFree ? (
            <PackageFree isTaxShown={!!taxType} isSaleOn={isSaleOn} />
          ) : (
            <PackagePrice
              amount={priceAmount || 0}
              currency={priceCurrency || 'US$'}
              cycles={cycles}
              selectedOffer={selectedOffer}
              productId={productId || ''}
              isEnabled={isEnabled || false}
              packageName={packageName}
              productIndex={productIndex}
              discountAmount={discountAmount}
              taxType={taxType}
              isCtaPrimary={isCTAPrimary}
              currentPlan={currentPlan}
              isSaleOn={isSaleOn}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withExperiments(Package));
